import {Injectable} from "@angular/core";
import {ExportChartImage} from "./export-chart-image";
import {Chart} from "chart.js";

@Injectable({
  providedIn: 'root'
})

/*
01/09/2025 - Kauan
processa os graficos de pizza, basicamente organiza a legenda pra direita,  pega os valores tratados (printfont) e plota a direita da legenda
*/
export class ProcessPieChart {
  saveDataChart: any;
  animationDuration: number;

  constructor(private exportChartImage: ExportChartImage) {
  }

  process(chart: any, printFont: any, originalFont: any, chartName: string) : void {
    this.saveCurrentData(chart, originalFont);

    chart.options.animation.duration = 1;
    chart.options.legend.position = 'right';
    chart.options.layout.padding.right = 130;
    chart.options.animation.onComplete = () => {
      const ctx = chart.ctx;
      ctx.font = Chart.helpers.fontString(
        11,
        Chart.defaults.global.defaultFontStyle,
        Chart.defaults.global.defaultFontFamily
      );
      ctx.textAlign = 'left';
      ctx.fillStyle = '#111111';
      ctx.textBaseline = 'bottom';
      chart.legend.legendItems.forEach((item, index) => {
        const hitBox = chart.legend.legendHitBoxes[index];
        const match = printFont.find(([label]) => label === item.text);
        if (match) {
          const [label, formattedValue] = match;
          ctx.fillText(formattedValue,hitBox.left + hitBox.width + 5,(hitBox.top + hitBox.height / 2) + 5);
        }
      });
    };
    chart.update();

    setTimeout( () =>{
      this.exportChartImage.save(chartName);
    }, 100);

    setTimeout( () =>{
      this.undoChanges(chart);
    }, 1000);
  }

  saveCurrentData(chart: any, originalFont: any) : void {
    this.saveDataChart = originalFont;
    this.animationDuration = chart.options.animation.duration;
  }

  undoChanges(chart: any) : void {
    chart.options.animation.onComplete = function () {};
    chart.options.legend.position = 'bottom';
    chart.options.animation.duration = 30;
    chart.options.layout.padding.right = 0;
    chart.data.labels = this.saveDataChart;
    chart.update();
  }

}
